
import CustomDrawer from './CustomDrawer.vue';
import { canCreatePortfolio } from '~/utils/behavior/portfolio-creation';
import CloseIcon from '../icons/CloseIcon.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'NoEligiblePortfolioDrawer',
  components: {
    CustomDrawer,
    CloseIcon,
  },
  props: {},
  data() {
    return {
      show: false,
    };
  },
  computed: {
    ...mapGetters('portfolio', ['myOwnedPortfolios', 'getMyPortfoliosRes']),
    ...mapGetters('authentication', [
      'isEmailConfirmed',
      'isVerifiedInfluencer',
    ]),
    canCreatePortfolio() {
      return canCreatePortfolio(
        this.isEmailConfirmed,
        this.myOwnedPortfolios.length,
        this.isVerifiedInfluencer
      );
    },
    portfolios() {
      return this.getMyPortfoliosRes?.data?.portfolios;
    },
    drawerTitle() {
      return this.getMyPortfoliosRes?.data?.portfolios?.length > 0
        ? this.$t('no_eligible_portfolio')
        : this.$t('no_portfolio');
    },
  },
  async mounted() {
    this.show = true;
  },
  methods: {
    ...mapActions('modals', ['toggleNoEligiblePortfoliosDrawer']),
    handleCloseDrawer() {
      this.show = false;
      setTimeout(() => {
        this.toggleNoEligiblePortfoliosDrawer(false);
      }, 100);
    },
    handleCreatePortfolioButtonClick() {
      this.handleCloseDrawer();
      this.$emit('onCreatePortfolio');
    },
  },
};
